/*
 * @Author: your name
 * @Date: 2021-11-09 17:30:44
 * @LastEditTime: 2021-11-09 19:36:22
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /qidian-stellaris/src/page/contact-selector-pro/js/utils/getDetail/getColleagueDetail.js
 */
import { envDomain } from '@/common/contact-selector/utils/domainConfig';

function getQQFriendDetailByUin(userIds) {
    return Vue.prototype.$_sAjax.crossPost(`${envDomain.gateway}/v2/org/batchProfile`, {
        fields: ['account', 'name', 'kfext', 'face'],
        kfexts: userIds
    });
}

export default function(userIds = []) {
    return new Promise(reslove => {
        getQQFriendDetailByUin(userIds)
            .then(res => {
                const resList = res.data.profiles;
                const hasDetailList = {};
                userIds.forEach(e => {
                    if (resList[e]) hasDetailList[e] = resList[e];
                });
                reslove(hasDetailList);
            })
            .catch(() => {
                reslove([]);
            });
    });
}
